import React, { useState } from "react";
import { StackedContainer } from "@poseidon/ui/styles/layout";
import { Button, Typography } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import ToasterMessage from "@poseidon/ui/components/ToasterMessage";
import { CreateSailorSchema } from "@poseidon/utils/authFieldUtils";
import { firebaseFunctions } from "@poseidon/firebase/firebase";

export default function CreateSailor() {
  const [error, setError] = useState();
  const [notification, setNotification] = useState({
    open: false,
    message: "",
  });

  return (
    <StackedContainer>
      <Typography pl={1} mt={2} variant="h6">
        Create new Sailor
      </Typography>

      <Formik
        initialValues={{
          email: "",
          firstName: "",
          lastName: "",
        }}
        validationSchema={CreateSailorSchema}
        onSubmit={async (values, { resetForm }) => {
          setError();
          try {
            await firebaseFunctions.createNewSailor(values);
            resetForm();
            setNotification({
              open: true,
              message: "Successfully created sailor",
            });
          } catch (error) {
            setError(error.message);
          }
        }}
      >
        {({ errors, touched }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
              minWidth: "400px",
            }}
          >
            <Field
              component={TextField}
              name="email"
              label="Email"
              margin="none"
              helperText={errors.email && "Email required"}
              error={errors.email && touched.email ? true : false}
            />
            <Field
              component={TextField}
              name="firstName"
              label="First Name"
              margin="none"
              helperText={errors.firstName && "First name required"}
              error={errors.firstName && touched.firstName ? true : false}
            />
            <Field
              component={TextField}
              name="lastName"
              label="Last Name"
              margin="none"
              helperText={errors.lastName && "Last name required"}
              error={errors.lastName && touched.lastName ? true : false}
            />
            {error && <Typography color="error">{error}</Typography>}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              margin="normal"
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
      <ToasterMessage
        open={notification.open}
        setOpen={(newState) =>
          setNotification({ ...notification, open: newState })
        }
        message={notification.message}
      />
    </StackedContainer>
  );
}
